import {Component, Input} from '@angular/core';

import {DetailField, DetailParams} from '../../../../shared';
import {ContactoDetailParams, EmpresasDetailParams} from '../../../models';
import {EMPRESA_DETAIL_DEFAULT_FIELDS} from "../../../constants";

@Component({
  selector: 'app-empresas-detail',
  templateUrl: './empresa-detail.component.html',
  styleUrls: ['./empresa-detail.component.scss']
})
export class EmpresaDetailComponent {
  @Input() title: string = null;
  fields: DetailField[] = [];
  detailParams: DetailParams = null;
  contactosDetailParams: ContactoDetailParams[] = [];

  constructor() {
  }

  _params: EmpresasDetailParams = null;

  @Input()
  set params(value: EmpresasDetailParams) {
    this._params = value;
    if (!value) {
      return;
    }

    this.fields = value.fields || EMPRESA_DETAIL_DEFAULT_FIELDS;

    const rows = this.fields
      .filter(f => f.name !== 'contactos')
      .filter(f => ((f.name !== 'empresaRut' || value.empresa.empresaRut != '0') && (f.name !== 'empresaPersonaCi' || value.empresa.empresaRut == '0')))
      .map(f => ({
        label: f.label,
        value: value.empresa[f.name]
      }));
    this.detailParams = {
      rows
    };
    if (this.fields.some(f => f.name === 'contactos')) {
      this.contactosDetailParams = this.params.empresa.contactos.map(
        contacto => ({contacto})
      );
    }
  }
}
